import * as React from 'react';

export const Tick = ({
  height = '20px',
  width = '20px',
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      role="img"
      {...props}
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="white"
      />
      <path
        d="M14.8228 9.42492L8.62809 15.6639L5.17676 12.2125V8.05324L8.62809 11.5046L14.867 5.26562V9.42492H14.8228Z"
        fill="#700E00"
      />
    </svg>
  );
};
